import React from 'react';
import { Box, Paper } from '@mui/material';

export default function FilterBar({ children, onSubmit }) {
  return (
    <Paper
      component={onSubmit ? 'form' : 'div'}
      onSubmit={onSubmit}
      sx={{ p: 2, mb: 2 }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-end',
          gap: 2,
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}
